import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: 45,
  },
  filtersContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: 37,
  },
  addButton: {
    width: 251,
  },
  search: {
    flex: 0.46,
    maxWidth: theme.spacing(151),
  },
  filters: {
    paddingLeft: 30,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  denomination: {
    color: theme.palette.common.black,
    fontWeight: 500,
  },
  tableItemDefaultStyle: {
    color: theme.palette.grey['400'],
  },
  searchBlock: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}));
